import { useCallback, useState } from 'react';
import { ApiLoginWarning } from 'Constants';
import { AUTH_SESSION } from 'Reducers/auth/types';
import { SHOW_MODAL } from 'Reducers/modal/types';
import { notifyApp } from 'Utilities/appCommunicator';
import i18n from 'Utilities/i18n';
import { store } from 'Utilities/store';
import { checkEmailVerification } from 'Services/auth';
const useClickContinueEmailVerificationButton = ({
  account_id,
  osType,
  osVersion,
  app,
  appVersion,
  installationId,
  handleApiRequestError
}) => {
  const [isLoading, setIsLoading] = useState(false);
  const handleContinueEmailVerificationButtonClick = useCallback(async () => {
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    try {
      var _authSession$authenti;
      const authSession = await checkEmailVerification({
        account_id,
        osType,
        osVersion,
        app,
        appVersion,
        installationId
      });
      if ((_authSession$authenti = authSession.authentication_steps) !== null && _authSession$authenti !== void 0 && _authSession$authenti.includes(ApiLoginWarning.EMAIL_VERIFICATION)) {
        store.dispatch({
          type: SHOW_MODAL,
          modalProps: {
            header: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.title'),
            details: i18n.t('CheckYourEmailRegistration.modals.verifyEmailDialog.body')
          }
        });
        return;
      }
      store.dispatch({
        type: AUTH_SESSION,
        authSession
      });
      notifyApp('adc-webview:signin', authSession);
    } catch (err) {
      const error = err;
      handleApiRequestError(error);
    } finally {
      setIsLoading(false);
    }
  }, [isLoading, account_id, osType, osVersion, app, appVersion, installationId, handleApiRequestError]);
  return {
    handleContinueEmailVerificationButtonClick,
    isLoading
  };
};
export default useClickContinueEmailVerificationButton;